import React, { useEffect, useState } from 'react'
import {
  popularListTypeData,
  categoryTypesData,
  likeTypesData,
  viewTypesData,
  DateofUpdate,
} from './DynamicListStaticData'
import AutoSuggestions from '../../Services/Queries/AutoSuggestions'
import ErrorMessage from './ErrorMessage'

export default function RenderTrendingFilterOptions(props) {
  const { listData, handleListData, dynamicListInfo } = props
  const [MovieName, setMovieName] = useState()
  const [personName, setPersonName] = useState()
  // console.log(listData.sortBy, 'listData.sortBylistData.sortBy')
  const styles = {
    searchItemStyle: {
      border: '1px solid #ccc',
      padding: '5px 13px',
      margin: '4px 6px',
    },
    selectedSearchItemStyle: {
      border: '1px solid #ccc',
      padding: '5px 13px',
      margin: '4px 6px',
      backgroundColor: '#ccc',
    },
  }
  const viewTypes = viewTypesData
  const likeTypes = likeTypesData
  const popularListType = popularListTypeData
  const categoryTypes = categoryTypesData
  const [searchData, setSearchData] = React.useState([])
  const [selectedMovieOrPerson, setSelectedMovieOrPersonData] = React.useState({})

  const [searchQuery, setSearchQuery] = React.useState('')
  const handleSearchMovie = async value => {
    setSearchQuery(value)
    const input = {
      search: value,
      type: 'movie',
      limit: 20,
      from: 0,
    }
    try {
      const searchData = await AutoSuggestions(input)
      // console.log('searchData', searchData)
      setSearchData(searchData && searchData.movieHits ? searchData.movieHits : [])
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleSearchPerson = async value => {
    setSearchQuery(value)
    const input = {
      search: value,
      type: 'person',
      limit: 20,
      from: 0,
    }
    try {
      const searchData = await AutoSuggestions(input)
      // console.log('searchData', searchData)
      setSearchData(searchData && searchData.personHits ? searchData.personHits : [])
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleSelectedMovieOrPerson = async (type, item) => {
    setSelectedMovieOrPersonData(item)
    setSearchData([])
    setMovieName(item.title_En ? item.title_En : item.title_Te ? item.title_Te : '')
    setSearchQuery('')
    if (type === 'person') {
      // console.log('personnnnnnnn')
      setPersonName(item.title_En ? item.title_En : item.title_Te ? item.title_Te : '')
    }

    props.handleListData(type === 'movie' ? 'movieID' : 'personID', item.PK)
  }

  useEffect(() => {
    if (dynamicListInfo.movieID !== null) {
      selectedMovieOrPerson.title_Te = dynamicListInfo.movieID
    } else if (dynamicListInfo.personID !== null) {
      selectedMovieOrPerson.name_Te = dynamicListInfo.personID
    }
  }, [])

  useEffect(() => {
    // console.log('iiiiiii')
    setMovieName(listData.movieID)
    setPersonName(listData.personID)
  }, [listData])

  const handleViewsAndLikes = () => {
    listData.likesType = ''
  }

  // console.log(listData.popularListType, 'selectedMovieOrPerson.title_En')
  return (
    <>
      <div>
        <label>{'Type'}</label>
        <div className='row d-flex ml-3'>
          {popularListType.map((popularListType, index) => (
            <div key={index} className='custom-control custom-radio col-md-2'>
              <input
                type='radio'
                onClick={() => handleListData('popularListType', popularListType.value)}
                checked={listData.popularListType === popularListType.value}
                id={`popularListType${popularListType.value}`}
                name='popularListType'
                className='custom-control-input'
              />
              <label
                className='custom-control-label'
                htmlFor={`popularListType${popularListType.value}`}
              >
                {popularListType.label}
              </label>
            </div>
          ))}
        </div>
        {listData.popularListType === 'movies' && (
          <>
            <label className='mt-2'>Search Movie</label>
            <span>Selected Movie :{MovieName}</span>
            <input
              onChange={e => handleSearchMovie(e.target.value)}
              type='text'
              className='form-control col-md-6'
              id='movieName'
              placeholder='Search Movie Name'
              value={searchQuery}
            />
            {!(selectedMovieOrPerson.title_Te || selectedMovieOrPerson.title_En) && (
              <ErrorMessage error={'Choose a Movie'} />
            )}

            <div className='d-flex flex-wrap justify-content-start'>
              {searchData.map((item, index) => (
                <span
                  onClick={() => handleSelectedMovieOrPerson('movie', item)}
                  className='cursor-pointer'
                  style={
                    selectedMovieOrPerson.PK === item.PK
                      ? styles.selectedSearchItemStyle
                      : styles.searchItemStyle
                  }
                  key={index}
                >
                  {item.title_En ? item.title_En : item.title_Te ? item.title_Te : ''}
                </span>
              ))}
            </div>
          </>
        )}

        {listData.popularListType === 'person' && (
          <>
            <label className='mt-2'>Search Person</label>
            <span>Selected Person :{personName}</span>
            <input
              onChange={e => handleSearchPerson(e.target.value)}
              type='text'
              className='form-control col-md-6'
              id='personName'
              placeholder='Search Person Name'
              value={searchQuery}
            />
            {!(personName || personName) && <ErrorMessage error={'Choose a Person'} />}
            <div className='d-flex flex-wrap justify-content-start'>
              {searchData.map((item, index) => (
                <span
                  onClick={() => handleSelectedMovieOrPerson('person', item)}
                  className='cursor-pointer'
                  style={
                    selectedMovieOrPerson.PK === item.PK
                      ? styles.selectedSearchItemStyle
                      : styles.searchItemStyle
                  }
                  key={index}
                >
                  {item.name_En ? item.name_En : item.name_Te ? item.name_Te : ''}
                </span>
              ))}
            </div>
          </>
        )}
      </div>
      <div>
        <label>{'Sort By:'}</label>
        <div className='row d-flex ml-3'>
          {categoryTypes.map((categoryTypeItem, index) => (
            <div key={index} className='custom-control custom-radio col-md-2'>
              <input
                type='radio'
                onClick={() => handleListData('popularListCategory', categoryTypeItem.value)}
                checked={listData.popularListCategory === categoryTypeItem.value}
                id={`popularListCategory${categoryTypeItem.value}`}
                name='popularListCategory'
                className='custom-control-input'
              />
              <label
                className='custom-control-label'
                htmlFor={`popularListCategory${categoryTypeItem.value}`}
              >
                {categoryTypeItem.label}
              </label>
            </div>
          ))}
        </div>
      </div>
      {listData.popularListCategory === 'views' && (
        <div>
          <label>{'Views'}</label>
          <div className='row d-flex ml-3'>
            {viewTypes.map((viewsTypeItem, index) => (
              <div key={index} className='custom-control custom-radio col-md-2'>
                <input
                  type='radio'
                  onChange={handleViewsAndLikes()}
                  onClick={() => handleListData('viewsType', viewsTypeItem.value)}
                  checked={listData.viewsType === viewsTypeItem.value}
                  id={`view${viewsTypeItem.value}`}
                  name='viewsType'
                  className='custom-control-input'
                />
                <label className='custom-control-label' htmlFor={`view${viewsTypeItem.value}`}>
                  {viewsTypeItem.label}
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
      {listData.popularListCategory === 'likes' && (
        <div>
          <label>{'Likes'}</label>
          <div className='row d-flex ml-3'>
            {likeTypes.map((likesTypeItem, index) => (
              <div key={index} className='custom-control custom-radio col-md-2'>
                <input
                  type='radio'
                  onClick={() => handleListData('likesType', likesTypeItem.value)}
                  checked={listData.likesType === likesTypeItem.value}
                  id={`like${likesTypeItem.value}`}
                  name='likesType'
                  className='custom-control-input'
                />
                <label className='custom-control-label' htmlFor={`like${likesTypeItem.value}`}>
                  {likesTypeItem.label}
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
      {/* DateUpdated */}
      {listData.popularListCategory === 'date' && (
        <div>
          <label>{'DateUpdated order'}</label>
          <div className='row d-flex ml-3'>
            {DateofUpdate.map((likesTypeItem, index) => {
              console.log(likesTypeItem.value, likesTypeItem, 'listData.likesType === ')
              console.log(listData.sortBy, 'listData.likesType ===sdfdsf ')

              return (
                <div key={index} className='custom-control custom-radio col-md-2'>
                  <input
                    type='radio'
                    onClick={() => handleListData('sortBy', likesTypeItem.value)}
                    checked={listData.sortBy === likesTypeItem.value}
                    id={`like${likesTypeItem.value}`}
                    // value={listData.sortBy}
                    name='likesType'
                    className='custom-control-input'
                  />
                  <label className='custom-control-label' htmlFor={`like${likesTypeItem.value}`}>
                    {likesTypeItem.label}
                  </label>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </>
  )
}
